import { Product } from 'src/types';
import { Meta } from './types';
import { ClientMarket } from '@prisjakt/web-app-config/types/client-market';
import { TranslateFunc } from '@prisjakt/ui-translate/src/translate-func';

export function graph(
  product: Product,
  meta: Meta,
  description: string,
  market: ClientMarket,
  t: TranslateFunc
) {
  return [
    {
      key: 'title',
      content: t('meta', 'product.og-title', meta),
    },
    { key: 'description', content: description },
    {
      key: 'url',
      content: market.domain + product.pathName,
    },
    { key: 'type', content: 'product' },
    product.priceSummary && {
      key: 'amount',
      content: product.priceSummary.regular || product.priceSummary.alternative,
    },
    {
      key: 'currency',
      content: market.currency,
    },
    product.category && {
      key: 'category',
      content: product.category.name,
    },
    product.media && { key: 'image', content: product.media.first },
  ].filter(Boolean);
}
